import React, { useState } from 'react';
import { Box, Tabs, Tab, Badge, Tooltip } from '@mui/material';
import BugsCleanup from './BugsCleanup';
import TestCasesCleanup from './TestCasesCleanup';
import RegressionSuiteHealth from './RegressionSuiteHealth';

const HealthInsights = ({ selectedProject, authenticatedUser, apiClient }) => {
  const [activeSubTab, setActiveSubTab] = useState('bugs');

  const handleSubTabChange = (event, newValue) => {
    setActiveSubTab(newValue);
  };

  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={activeSubTab} onChange={handleSubTabChange} aria-label="health insights tabs">
          <Tab
            label="Bugs Cleanup"
            value="bugs"
            sx={{ textTransform: 'none', fontSize: '1rem', fontWeight: 500 }}
          />
          <Tab
            label="Test Cases Cleanup"
            value="test-cases"
            sx={{ textTransform: 'none', fontSize: '1rem', fontWeight: 500 }}
          />
          <Tab
            label="Regression Coverage"
            value="regression-suite"
            sx={{ textTransform: 'none', fontSize: '1rem', fontWeight: 500 }}
          />
          <Tooltip title="Coming Soon - Product Knowledge cleanup will be available in a future release">
            <Tab
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <span>Product Knowledge Cleanup</span>
                  <Badge
                    badgeContent="Soon"
                    color="primary"
                    sx={{
                      '& .MuiBadge-badge': {
                        fontSize: '0.65rem',
                        height: '18px',
                        minWidth: '32px',
                        padding: '0 6px'
                      }
                    }}
                  />
                </Box>
              }
              value="pkb"
              disabled
              sx={{ textTransform: 'none', fontSize: '1rem', fontWeight: 500 }}
            />
          </Tooltip>
        </Tabs>
      </Box>

      <Box sx={{ flex: 1, overflow: 'auto' }}>
        {activeSubTab === 'bugs' && (
          <BugsCleanup
            selectedProject={selectedProject}
            authenticatedUser={authenticatedUser}
            apiClient={apiClient}
          />
        )}
        {activeSubTab === 'test-cases' && (
          <TestCasesCleanup
            selectedProject={selectedProject}
            authenticatedUser={authenticatedUser}
            apiClient={apiClient}
          />
        )}
        {activeSubTab === 'regression-suite' && (
          <RegressionSuiteHealth
            selectedProject={selectedProject}
            authenticatedUser={authenticatedUser}
            apiClient={apiClient}
          />
        )}
        {activeSubTab === 'pkb' && (
          <Box sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>
            Product Knowledge Cleanup is coming soon. This feature will help identify and clean up outdated product knowledge entries.
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default HealthInsights;



